import './step-contract.scss'

const StepContract = () => <div className="shop-step__contract">Contract here</div>

export default StepContract
